
import { mapGetters } from 'vuex'
import { serializedFilters } from '@/utils/getSearchFilters'

export default {
  name: 'SearchMixin',
  computed: {
    ...mapGetters({
      offers: 'search/getOffers',
      offersSponsored: 'search/getSponsoredOffers',
      currentPage: 'search/getCurrentPage',
      maxPage: 'search/getMaxPages',
      maxResults: 'search/getMaxResults',
      isLoading: 'search/isLoading',
      getFilters: 'search/getFilters'
    }),
    pages () {
      if (this.currentPage < 1 || this.currentPage > this.maxPage) return []
      let delta = 5,
        left = this.currentPage - delta,
        right = this.currentPage + delta + 1,
        result = []

      result = Array.from({ length: this.maxPage }, (v, k) => k + 1)
        .filter(i => i && i >= left && i < right)

      return result
    },
    showPrecedent () {
      return !!this.currentPage && this.currentPage > 1 && this.currentPage <= this.maxPage
    },
    showNext () {
      return this.currentPage > 0 && this.currentPage < this.maxPage
    },
    precedentURL () {
      return this.pageURL(this.currentPage - 1)
    },
    nextURL () {
      return this.pageURL(this.currentPage + 1)
    },
  },
  methods: {
    search2 (filters) {
      const f = { ...filters }
      delete f.sort
      delete f.order
      f.page = 1
      f.sort = ''
      f.order = 'desc'
      if (f.categories && f.categories.length && f.categories[0] !== null) {
        delete f.categories
        const category = this.$store.getters['layout/getFlattedCategories'].find(c => c.id === filters.categories[0])
        window.location = this.localePath({
          name: 'categories-slug',
          params: { slug: category.slug },
          query: serializedFilters(f)
        })
      } else if (f.brands && f.brands.length && f.brands[0] !== null) {
        delete f.brands
        const brand = this.$store.getters['layout/getBrands'].find(c => c.id2 === filters.brands[0])
        window.location = this.localePath({
          name: 'brands-slug',
          params: { slug: brand.slug },
          query: serializedFilters(f)
        })
      } else {
        window.location = this.localePath({
          name: 'search',
          query: serializedFilters(f)
        })
      }
    },
    pageURL (page) {
      const { name } = this.$route
      const query = { ...this.$route.query }
      query.page = page
      return this.localePath({ name: name.split('__')[0], query })
    },

    async pushTo (url) {
      if (window.url === url) return
      await this.$router.push(url)
      if (process.client) {
        const el = document.getElementById('offers')
        setTimeout(() => {
          if (el) {
            window.scrollTo({ top: (this.$isMobile || this.$isTablet) ? el.offsetTop - 180 : 0, behavior: 'smooth' })
          }
        }, 100)
      }
    },
  }
}
